import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import nl from './locales/nl.json';
import en from './locales/en.json';
import de from './locales/de.json';

// Dutch is the default language for KITEIQ. We only auto-detect from a previously
// stored choice (localStorage) so first-time visitors always start in Dutch.
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en', 'de'],
    detection: {
      // querystring (?lng=nl|en|de) first so crawlers/hreflang variants resolve
      // to the right language, then fall back to the visitor's stored choice.
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'kiteiq_lang',
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

export default i18n;
